import { styled } from '@mui/material/styles';

import { fontSize } from '@verantos-dev/shared-ui-components/tokens';

export const ViewModeContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  fontFamily: 'Roboto, sans-serif',
});

export const ViewModeLabel = styled('div')(({ theme }) => ({
  fontSize: fontSize[14],
  fontWeight: 400,
  lineHeight: '24px',
  color: theme.palette.text.secondary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
}));

export const ViewModeValue = styled('div')({
  fontSize: fontSize[16],
  fontWeight: 600,
  lineHeight: '24px',
  // TODO: no VDS token for this value — needs designer input (#252a36)
  color: '#252a36',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
});
